export const dataProperties = {
  name: 'Name',
  description: 'Description',
  price: 'Price',
};

export const convertModelToConfig = mtModel => ({
  name: mtModel[dataProperties.name],
  description: mtModel[dataProperties.description],
  price: mtModel[dataProperties.price],
});

export const covertConfigToModel = config => ({
  [dataProperties.name]: config.name,
  [dataProperties.description]: config.description,
  [dataProperties.price]: config.price,
});
